import { Field } from 'formik';
import type { FieldProps } from 'formik';

import { AccountSelector } from 'modules/common/smartComponents/accountSelector/AccountSelector';
import { UNASSIGNED_VALUE as ACCOUNT_UNASSIGNED_VALUE } from 'modules/common/smartComponents/accountSelector/data/constants';

import type { FormData } from '../types';
import { HorizontalFormControl } from './HorizontalFormControl';

export const AccountFilter = () => {
  return (
    <HorizontalFormControl label="Account">
      <Field name="accountIn">
        {({ field, form }: FieldProps<FormData['accountIn'], FormData>) => (
          <AccountSelector
            isMulti
            allowUnassignedOption
            onChange={(selectedCompanies: unknown[]) => {
              if (!selectedCompanies) {
                form.setFieldValue(field.name, []);
                form.setFieldValue('accountIsUnassigned', false);
              } else if (selectedCompanies.includes(ACCOUNT_UNASSIGNED_VALUE)) {
                form.setFieldValue(field.name, []);
                form.setFieldValue('accountIsUnassigned', true);
              } else {
                form.setFieldValue(
                  field.name,
                  selectedCompanies.map((c: any) => c.id),
                );
                form.setFieldValue('accountIsUnassigned', false);
              }
            }}
            value={
              form.values.accountIsUnassigned
                ? [ACCOUNT_UNASSIGNED_VALUE]
                : form.values.accountIn
            }
          />
        )}
      </Field>
    </HorizontalFormControl>
  );
};
